import { useEffect } from 'react';
import { useSelector } from "react-redux";

const ScrollToTop = () => {
    const pathname = useSelector(state => state.router.location.pathname);
    const search = useSelector(state => state.router.location.search);
    // PUSH=画面遷移 / POP=戻る・進む / REPLACE=同一ページ内のURL書き換え
    const action = useSelector(state => state.router.action);

    // Update after changing path or query
    useEffect(() => {
        // 検索条件フィルタ(発注処理・発注履歴)は条件を history.replace で
        // URLに同期する。これは「同じ画面の状態更新」なのでスクロールしない
        // (毎回トップに飛ぶと、スクロールして一覧を見ながらの絞り込みができない)。
        // 画面遷移(push)や戻る/進む(pop)は従来どおりトップへ戻す。
        if (action === 'REPLACE') return;
        try {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        } catch (error) {
            // just a fallback for older browsers
            window.scrollTo(0, 0);
        }
    }, [pathname, search, action]);

    return null;
};

export default ScrollToTop
